import { render, staticRenderFns } from "./PromoAdd.vue?vue&type=template&id=13d004a6"
import script from "./PromoAdd.vue?vue&type=script&lang=js"
export * from "./PromoAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports